/**
 * Created by seven on 2017/3/6.
 */

import CryptoJS from 'crypto-js'
var AESSecret = 'RePaaS_Admin'

export default {
  AESDecrypt (decrypted) {
    // console.log(decrypted)
    if (decrypted) {
      var bytes = CryptoJS.AES.decrypt(decrypted.toString(), AESSecret)
      return bytes.toString(CryptoJS.enc.Utf8)
    }
  },
  AESEncrypt (value) {
    return CryptoJS.AES.encrypt(value, AESSecret)
  },
  createHash (password) {
    if (password !== '') {
      var passwordSalt = CryptoJS.enc.Hex.parse('')
      var derivedKey = CryptoJS.PBKDF2(password, passwordSalt, { iterations: 1000, keySize: 256 / 32 })

      return CryptoJS.enc.Hex.stringify(derivedKey)
    } else {
      return ''
    }
  }
}
